import { Button, Dialog, DialogContent, Grid, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";
import { Phone, SupportIcon } from "src/icons/core";
import { Instagram, Telegram, Whatsapp } from "src/icons/socials";

const actions = [
  {
    name: "مرکزتماس",
    icon: <Phone color="success" sx={{ color: "primary", fill: "primary" }} />,
  },
  {
    name: "Whatsapp",
    icon: <Whatsapp sx={{ color: "primary", fill: "primary" }} />,
  },
  {
    name: "Telegram",
    icon: <Telegram sx={{ color: "primary", fill: "primary" }} />,
  },
  {
    name: "تیکت",
    icon: <SupportIcon sx={{ color: "primary", fill: "primary" }} />,
  },
];

export const SupportProductButton = ({ buttonProps }) => {
  const router = useRouter();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = (action) => {
    if (action === "Whatsapp") {
      window.open(
        "https://api.whatsapp.com/send?phone=+989175113478",
        "_blank"
      );
    } else if (action === "Telegram") {
      window.open("https://t.me/+-hhFXt4qvWIxYjhk", "_blank");
    } else if (action === "مرکزتماس") {
      window.open("tel:02191031644", "_blank");
    } else if (action === "تیکت") {
      router.push("/tickets");
    }
    setOpen(false);
  };
  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        {...buttonProps}
        onClick={handleOpen}
      >
        ارتباط با پشتیبانی
      </Button>

      {/* <Button
        variant="outlined"
        sx={{ color: "black", display: { lg: "none" } }}
        size="small"
        color="secondary"
        onClick={handleOpen}
      >
        ارتباط با پشتیبانی
      </Button> */}

      <Dialog maxWidth="sm" open={open} onClose={handleClose}>
        <DialogContent>
          <Typography mb={5} textAlign={"center"} fontWeight={600}>
            برای ارتباط با پشتیبانی یکی از روش های زیر را انتخاب نمایید
          </Typography>
          <Grid container justifyContent={"space-between"}>
            {actions.map((action) => (
              <Grid xs={6} p={1} item justifyContent={"center"}>
                <Button
                  key={action.name}
                  fullWidth
                  variant="outlined"
                  endIcon={action.icon}
                  sx={{ color: "black" }}
                  onClick={() => handleClose(action.name)}
                >
                  {action.name}
                </Button>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
